export default "__VITE_ASSET__BbI12SUF__"